import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
const SubsVault = React.lazy(() => import('./design/SubsVault'))
const PhoneImportFixture = React.lazy(() => import('./design/PhoneImportFixture'))
const CrewDayFixture = React.lazy(() => import('./design/CrewDayFixture'))
const JobPhotosVault = React.lazy(() => import('./fixtures/JobPhotosVault'))
const JobFieldNotesFixture = React.lazy(() => import('./design/JobFieldNotesFixture'))
const CrewChecklistFixture = React.lazy(() => import('./design/CrewChecklistFixture'))
import './index.css'
import { reportWebVitals } from './hooks/useWebVitals'
import { installFocusAssist } from './components/ui/focusAssist'
import { initTheme } from './lib/theme'

// Isolated synthetic fixture: never mount session restore or health polling.
const SiteCheckinFixture = lazy(() => import('./pages/design/SiteCheckinFixture'))

// Aurora or iOS, light or dark (index.html already painted it; this follows
// the device while on Auto).
initTheme()

// Keyboard: one Tab stop per radio group, arrow keys inside it, and focused
// chips scrolled clear of strip edges — app-wide, public pages included.
installFocusAssist()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {window.location.pathname === '/vault/subs-vendors'
      ? <React.Suspense fallback={null}><SubsVault /></React.Suspense>
      : window.location.pathname === '/__design/phone-import'
      ? <React.Suspense fallback={null}><PhoneImportFixture /></React.Suspense>
      : window.location.pathname === '/__design/crew-day'
      ? <React.Suspense fallback={null}><CrewDayFixture /></React.Suspense>
      : window.location.pathname === '/vault/job-photos'
      ? <React.Suspense fallback={<p>Loading…</p>}><JobPhotosVault /></React.Suspense>
      : window.location.pathname === '/__design/site-checkin'
      ? <Suspense fallback={<p>Loading fixture…</p>}><SiteCheckinFixture /></Suspense>
      : window.location.pathname === '/__design/job-notes'
      ? <React.Suspense fallback={<p>Loading…</p>}><JobFieldNotesFixture /></React.Suspense>
      : window.location.pathname === '/__design/crew-checklist'
      ? <React.Suspense fallback={<p>Loading preview…</p>}><CrewChecklistFixture /></React.Suspense>
      : <App />}
  </React.StrictMode>,
)

reportWebVitals()
